/**
 * Site Configuration — Exo Entertainment
 * Centralized configuration for branding, site metadata, and constants
 */

const siteConfig = {
  // Site Branding
  name: "Exo Entertainment",
  fullName: "Exo Entertainment",
  legalName: "Exo Entertainment Studios Inc.",
  shortName: "Exo Entertainment",

  // Site Metadata
  title: "Exo Entertainment — Private VIP Entertainment | Calgary, AB",
  description: "Private VIP dance shows, bachelor parties, and curated entertainment experiences in Calgary. Persona-driven performers, premium private experiences.",
  tagline: "Calgary's Premier Private Entertainment",

  // URLs
  domain: "exoentertainment.ca",
  url: "https://exoentertainment.ca",
  apiUrl: process.env.REACT_APP_API_URL || "/api",

  // Social Links
  social: {
    instagram: "https://instagram.com/exoentertainment",
    twitter: "",
    email: "booking@exoentertainment.ca",
  },

  // Legal
  copyright: {
    holder: "Exo Entertainment Studios Inc.",
    year: "2026",
    text: "All rights reserved",
  },

  // Features
  features: {
    blog: false,           // Enable later for SEO content
    projects: false,       // Not needed
    newsletter: false,     // Enable later for client list
    mailingList: false,
    emailCampaigns: false,
    ageGate: true,         // 18+ verification splash
    booking: true,         // Booking inquiry form
    entertainers: true,    // Performer profiles
    hiring: true,          // Recruitment page

    // Disabled legacy features
    gettingStarted: false,
    spotlightProjects: false,
    buildSomething: false,
    pinkpillSection: false,
    improv: false,
  },

  // Development Settings
  dev: {
    mode: process.env.REACT_APP_DEV_MODE === "true",
  },

  // Hero Configuration
  hero: {
    buttonText: "Book Now",
    buttonStyle: "gold",
    defaultLink: "/book",
    useBlogPost: false,
  },

  // Entertainer Profiles
  entertainers: [
    {
      id: "opal",
      name: "Opal",
      tagline: "Playful · High-Energy · Party Vibe",
      bio: "Opal brings the energy. Playful, magnetic, and impossible to look away from — she turns any room into a celebration. Perfect for bachelor parties, group events, or anyone who wants to feel alive.",
      style: "High-energy dance, playful interaction, party atmosphere",
      image: "/images/entertainers/opal-placeholder.jpg",
    },
    {
      id: "ember",
      name: "Ember",
      tagline: "Intense · Controlled · Dark Seduction",
      bio: "Ember commands attention without asking for it. Slow, deliberate, hypnotic — her performances are an experience in control and surrender. For those who want something they'll think about for weeks.",
      style: "Slow-burn seduction, controlled intensity, intimate atmosphere",
      image: "/images/entertainers/ember-placeholder.jpg",
    },
  ],

  // Services & Pricing (CAD)
  services: [
    {
      name: "Private VIP Dance",
      description: "Solo private show in curated hotel room setting. Choose your performer. Complimentary beverage. No contact.",
      price: "$150 / 30 min | $250 / hr",
      icon: "💎",
    },
    {
      name: "Couples Experience",
      description: "Private VIP dance for couples. Intimate, tasteful, designed to be enjoyed together.",
      price: "$200 / 30 min | $350 / hr",
      icon: "💕",
    },
    {
      name: "Bachelor Party",
      description: "High-energy show for groups. Outcall to your location within Calgary. Custom packages available.",
      price: "$400 / hr | $650 / 2 hrs",
      icon: "🎉",
    },
    {
      name: "Bachelorette Party",
      description: "Male or female entertainers for your celebration.",
      price: "Inquire",
      icon: "🥂",
    },
    {
      name: "Duo Show",
      description: "Two-performer show. Double the energy, double the experience.",
      price: "$600 / hr",
      icon: "✨",
    },
    {
      name: "Private Event",
      description: "Birthdays, divorce parties, custom occasions within Calgary.",
      price: "Custom Quote",
      icon: "🎭",
    },
    {
      name: "Topless Hosting",
      description: "Topless server/hostess for your event. 2-4 hour bookings.",
      price: "$75–100 / hr",
      icon: "🍸",
    },
  ],

  // Location
  location: {
    city: "Calgary",
    province: "AB",
    country: "Canada",
    serviceArea: "Calgary city limits",
  },

  // Contact
  contact: {
    email: "booking@exoentertainment.ca",
    phone: "", // Add when ready
    available: "24/7",
  },

  // Theme/Styling
  theme: {
    primaryColor: "#7c3aed",    // Deep purple
    secondaryColor: "#C9A96E",  // Gold
    accentColor: "#a855f7",     // Light purple
    headingFont: "Playfair Display",
    bodyFont: "Montserrat",
  },
};

// Helper functions
export const getSiteName = () => siteConfig.name;
export const getSiteTitle = () => siteConfig.title;
export const getSiteDescription = () => siteConfig.description;
export const getCopyrightText = () =>
  `Copyright ${siteConfig.copyright.holder} © ${siteConfig.copyright.year} ${siteConfig.copyright.text}`;

export default siteConfig;
